import { HttpError } from 'react-admin';
import { toJS } from 'mobx';
import { socket } from './socket';
import { store } from './App';


const getResource = (name) => {
  if (name === 'attorneys')
    return store.availableAttorneys;
  if (name === 'clients')
    return store.availableClients;
  return null;
}

const getDelete = (name, sync) => {
  if (name === 'attorneys')
    return (id) => { store.deleteAttorney(id, sync) };
  if (name === 'clients')
    return (id) => { store.deleteClient(id, sync) };
  return null;
}

const getMatcher = (name) => {
  if (name === 'attorneys')
    return (q, item) => { return item && item.id.toUpperCase().includes(q) ||
                          item.name.toUpperCase().includes(q) }; 
  if (name === 'clients')
    return (q, item) => { return item && item.id.toUpperCase().includes(q) ||
                          item.name.toUpperCase().includes(q) ||
                          item.contact.toUpperCase().includes(q) };
  return null;
}

const sorter = (a, b) => {
  return a<b ? -1 : a>b ? 1 : 0;
}

// Make changes to the Store, and asynchronously push those changes back to the Server.
const ptoProvider = {

  getList: (resource, params) => {
    console.log('getList', resource, params);
    let items = getResource(resource);
    if (!items)
      return ptoProviderOld.getList(resource, params);
    items = Object.values(toJS(items));
    //console.log('Items', items);
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    let q = params.filter.q;
    let matcher = getMatcher(resource);
    if (q) {
      q = q.toUpperCase();
      items = items.filter(a => matcher(q, a)); 
    }
    let total = items.length;
    items.sort((a,b) => order === 'ASC' ?
               sorter(a[field], b[field]) : sorter(b[field], a[field]));
    //console.log('Sorted Items', field, order, items[0][field]);
    items = items.slice((page-1)*perPage, page*perPage);
    return Promise.resolve({data: items, total: total});
  },

  getOne: (resource, params) => {
    console.log('getOne', resource, params);
    let items = getResource(resource);
    if (!items)
      return ptoProviderOld.getOne(resource, params);
    //console.log('Items', toJS(items));
    return Promise.resolve({data: items[params.id]});
  },

  getMany: (resource, params) => {
    console.log('getMany: not implemented yet');
  },

  getManyReference: (resource, params) => {
    console.log('getManyRef: not implemented yet');
  },

  update: (resource, params) => {
    console.log('update', resource, params);
    let items = getResource(resource);
    if (!items)
      return ptoProviderOld.update(resource, params);
    items[params.data.id] = params.data;
    socket.emit(resource, {workspace: '', op: 'update', data: params.data});
    return Promise.resolve({data: params.data});
  },

  updateMany: (resource, params) => {
    console.log('updateMany: not implemented yet');
  },

  create: (resource, params) => {
    console.log('create', resource, params);
    let items = getResource(resource);
    if (!items)
      return ptoProviderOld.create(resource, params);
    if (items[params.data.id])
      return Promise.reject("Already exists: " + params.data.id);
    items[params.data.id] = params.data;
    socket.emit(resource, {workspace: '', op: 'create', data: params.data});
    return Promise.resolve({data: params.data});
  },

  delete: (resource, params) => {
    console.log('delete', resource, params);
    let deleter = getDelete(resource, true); 
    if (!deleter)
      return ptoProviderOld.delete(resource, params);
    deleter(params.id);
    // we will sync, so no need to do this
    // socket.emit(resource, {workspace: '', op: 'delete', id: params.id});
    return Promise.resolve({data: params.id});
  },

  deleteMany: (resource, params) => {
    console.log('deleteMany', resource, params);
    let deleter = getDelete(resource, false);
    if (!deleter)
      return ptoProviderOld.deleteMany(resource, params);
    params.ids.forEach((id) => deleter(id));
    socket.emit(resource, {workspace: '', op: 'delete_many', ids: params.ids});
    return Promise.resolve({data: params.ids});
  }
};


const _handleResponse = (resolve, reject, msg, op) => {
  if (msg.op === op) {
    //console.log('update rcv response', JSON.stringify(msg, null, 2));
    if (msg.status === 'OK') {
      return resolve(msg);
    }
    else {
      console.log('Received error');
      //return reject(new HttpError(msg.data, 400, msg.data));
      return reject("Error: " + msg.data);
    }
  }
  else {
    console.log('Error: op != msg.op', op, JSON.stringify(msg, null, 2));
    return reject(new HttpError(msg.data, 400, 'Internal error, msg.op != op'));
  }
}

const ptoProviderOld = {

  getList: (resource, params) => {
    console.log('getList', resource, params);
    let _getList = () => {
      return new Promise((resolve, reject) => {
        let listener = (msg) => {
          console.log('getList rcv response', msg);
          socket.off(resource + '_response', listener);
          return _handleResponse(resolve, reject, msg, 'list');
        };
        socket.on(resource + '_response', listener);
        socket.emit(resource, {workspace: '', op: 'list', parms: params});
      });
    };
    return _getList().then((msg) => {
      return msg.data;
    });
  },

  getOne: (resource, params) => {
    console.log('getOne', resource, params);
    let _getOne = () => {
      return new Promise((resolve, reject) => {
        let listener = (msg) => {
          socket.off(resource + '_response', listener);
          if (msg.op === 'get') {
            console.log('getOne rcv response', JSON.stringify(msg, null, 2));
            resolve(msg);
          }
        };
        socket.on(resource + '_response', listener);
        socket.emit(resource, {workspace: '', op: 'get', id: params.id});
      });
    };
    return _getOne().then((msg) => { return { data: msg.data } });
  },

  getMany: (resource, params) => {
    console.log('getMany: not implemented yet');
  },

  getManyReference: (resource, params) => {
    console.log('getManyRef: not implemented yet');
  },

  update: (resource, params) => {
    console.log('update', resource, params);
    let _update = () => {
      return new Promise((resolve, reject) => {
        let listener = (msg) => {
          socket.off(resource + '_response', listener);
          _handleResponse(resolve, reject, msg, 'update');
        };
        socket.on(resource + '_response', listener);
        socket.emit(resource, {workspace: '', op: 'update', data: params.data});
      });
    };
    return _update().then((msg) => { return { data: params.data } });
  },

  updateMany: (resource, params) => {
    console.log('updateMany: not implemented yet');
  },

  create: (resource, params) => {
    let _create = () => {
      return new Promise((resolve, reject) => {
        let listener = (msg) => {
          console.log('create rcv response', JSON.stringify(msg, null, 2));
          socket.off(resource + '_response', listener);
          return _handleResponse(resolve, reject, msg, 'create')
        };
        socket.on(resource + '_response', listener);
        socket.emit(resource, {workspace: '', op: 'create', data: params.data});
      });
    };
    return _create().then((msg) => { return { data: params.data } });
  },

  delete: (resource, params) => {
    console.log('delete', resource, params);
    let _delete = () => {
      return new Promise((resolve, reject) => {
        let listener = (msg) => {
          console.log('delete rcv response', JSON.stringify(msg, null, 2));
          socket.off(resource + '_response', listener);
          return _handleResponse(resolve, reject, msg, 'delete');
        };
        socket.on(resource + '_response', listener);
        socket.emit(resource, {workspace: '', op: 'delete', id: params.id});
      });
    };
    return _delete().then((msg) => { return { data: msg.data }; });
  },

  deleteMany: (resource, params) => {
    console.log('deleteMany', resource, params);
    let _delete = () => {
      return new Promise((resolve, reject) => {
        let listener = (msg) => {
          console.log('deleteMany rcv response', JSON.stringify(msg, null, 2));
          socket.off(resource + '_response', listener);
          return _handleResponse(resolve, reject, msg, 'delete_many');
        };
        socket.on(resource + '_response', listener);
        socket.emit(resource, {workspace: '', op: 'delete_many', ids: params.ids});
      });
    };
    return _delete().then((msg) => { return { data: msg.data }; });
  }
};

export default ptoProvider;

